import axios from 'axios'
import { API } from './url'

function errMsg(e, fallback) {
  return (e.response && e.response.data && e.response.data.message) || fallback
}

export default {
  listAll: function(success, error) {
    axios.get(API.teamMembers.list)
      .then(function(r) { success(r.data) })
      .catch(function(e) { error(errMsg(e, 'Failed to load team members')) })
  },

  listActive: function(success, error) {
    axios.get(API.teamMembers.list, { params: { activeOnly: true } })
      .then(function(r) { success(r.data) })
      .catch(function(e) { error(errMsg(e, 'Failed to load team members')) })
  },

  create: function(form, success, error) {
    axios.post(API.teamMembers.list, form)
      .then(function(r) { success(r.data) })
      .catch(function(e) { error(errMsg(e, 'Failed to create member')) })
  },

  update: function(id, form, success, error) {
    axios.put(API.teamMembers.detail(id), form)
      .then(function(r) { success(r.data) })
      .catch(function(e) { error(errMsg(e, 'Failed to update member')) })
  },

  deactivate: function(id, success, error) {
    axios.put(API.teamMembers.deactivate(id))
      .then(function(r) { success(r.data) })
      .catch(function(e) { error(errMsg(e, 'Failed to deactivate member')) })
  },

  activate: function(id, success, error) {
    axios.put(API.teamMembers.activate(id))
      .then(function(r) { success(r.data) })
      .catch(function(e) { error(errMsg(e, 'Failed to activate member')) })
  }
}
